import React from 'react';
import { DataItem, PaperContent, ButtonWithLoader, Button } from 'virtues-bootstrap';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { map } from 'ramda';

import { mapIndex } from 'utilities/ramda';

import s from './styles.module.scss';

const SidebarPatientInfo = ({ data, t, isResearcher, updateLoading, patientUpdate, patientId }) => {
  const handleClick = () => patientUpdate({ id: patientId });
  return (
    <PaperContent className={s.sidebarPaper} data-test="contactsDetails">
      {map(
        ({ title, items }) => (
          <DataItem className={s.dataItem} key={title} title={t(title)}>
            {mapIndex(
              ({ title: itemTitle, value }, index) => (
                <div key={index}>
                  {itemTitle && `${t(itemTitle)}: `}
                  {value}
                </div>
              ),
              items,
            )}
          </DataItem>
        ),
        data,
      )}
      {isResearcher && (
        <div className={s.buttons}>
          <Button
            className={s.bottomButton}
            component={Link}
            to={`/patient/${patientId}/edit-information`}
            outlined
            variant="primary"
          >
            {t('patient.editInformation')}
          </Button>

          <ButtonWithLoader
            className={s.bottomButton}
            childrenClassName={s.shortLabel}
            disabled={updateLoading}
            loading={updateLoading}
            onClick={handleClick}
          >
            {t('syncWithRedcap')}
          </ButtonWithLoader>
        </div>
      )}
    </PaperContent>
  );
};

SidebarPatientInfo.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          value: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,
  t: PropTypes.func.isRequired,
  isResearcher: PropTypes.bool.isRequired,
  patientUpdate: PropTypes.func.isRequired,
  updateLoading: PropTypes.bool.isRequired,
  patientId: PropTypes.string.isRequired,
};

export default withTranslation()(SidebarPatientInfo);
